
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.989 2.167C7.008 2.167 2.165 7.02 2.165 13s4.843 10.834 10.822 10.834c5.991 0 10.845-4.854 10.845-10.834 0-5.98-4.854-10.833-10.844-10.833zm7.507 6.5H17.3a16.955 16.955 0 00-1.495-3.857 8.699 8.699 0 014.691 3.857zm-7.497-4.29c.9 1.3 1.604 2.74 2.07 4.29H10.93c.466-1.55 1.17-2.99 2.07-4.29zm-8.385 10.79A8.929 8.929 0 014.333 13c0-.747.108-1.473.281-2.166h3.662A17.89 17.89 0 008.124 13c0 .737.065 1.452.152 2.167H4.614zm.889 2.167h3.196a16.954 16.954 0 001.495 3.856 8.652 8.652 0 01-4.691-3.856zm3.196-8.667H5.503a8.652 8.652 0 014.69-3.857A16.954 16.954 0 008.7 8.667zm4.3 12.957c-.899-1.3-1.603-2.741-2.069-4.29h4.139a15.26 15.26 0 01-2.07 4.29zm2.535-6.457h-5.07c-.097-.715-.173-1.43-.173-2.167 0-.736.076-1.462.173-2.166h5.07A15.8 15.8 0 0115.708 13c0 .737-.076 1.452-.174 2.167zm.271 6.023a16.955 16.955 0 001.495-3.856h3.196a8.699 8.699 0 01-4.69 3.856zm1.918-6.023c.086-.715.151-1.43.151-2.167 0-.736-.065-1.451-.151-2.166h3.661c.174.693.282 1.419.282 2.166 0 .748-.108 1.474-.282 2.167h-3.661z"}})])
          )
        }
      }
    